import { render, staticRenderFns } from "./ShopSelectionPage.vue?vue&type=template&id=608e36bd&scoped=true"
import script from "./ShopSelectionPage.vue?vue&type=script&lang=js"
export * from "./ShopSelectionPage.vue?vue&type=script&lang=js"
import style0 from "./ShopSelectionPage.vue?vue&type=style&index=0&id=608e36bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608e36bd",
  null
  
)

export default component.exports